import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const CustomerLayout = lazy(() => import('src/layout/customer'));
const CustomerTrack = lazy(() => import('src/views/CustomerTrack/Views/CustomerTrack'));
const CustomerAddresses = lazy(() => import('src/views/CustomerTrack/Views/CustomerAddresses'));
const FreelanceCustomerOrderTrack = lazy(() => import('src/views/CustomerTrack/Views/FreelanceCustomerOrderTrack'));
const CustomerLocationForm = lazy(() => import('src/views/CustomerTrack/Views/CustomerLocationForm'));
const UpdateTaskAddress = lazy(() => import('src/views/CustomerTrack/Views/UpdateTaskAddress'));
const RescheduleOrder = lazy(() => import('src/views/CustomerTrack/Views/RescheduleOrder'));
const ComplaintDriver = lazy(() => import("src/views/CustomerTrack/Views/ComplaintDriver"));
const ReviewDriver = lazy(() => import("src/views/CustomerTrack/Views/ReviewDriver"));
const RedirectToTrackingUrl = lazy(() => import("src/services/public/views/redirect-to-tracking-url"));
const OrderCustomerPayment = lazy(() => import("src/services/public/views/order-customer-payment"));
const CustomerAddNewAddress = lazy(() => import("src/views/CustomerTrack/Views/CustomerAddNewAddress"));
const AddressSelectionSuccess = lazy(() => import("src/views/CustomerTrack/Views/AddressSelectionSuccess"));

const customerRoutes = () => (
    <>
        <Route path="ref/:refId" element={<RedirectToTrackingUrl />} />
        <Route path=":refId" element={<RedirectToTrackingUrl />} />
        <Route path="transaction" element={<OrderCustomerPayment />} />
        <Route path="address" element={<CustomerLayout logotype='light' />}>
            <Route path=":id" element={<CustomerAddresses />} />
            <Route path="add/:id" element={<CustomerAddNewAddress />} />
            <Route path="success/:id" element={<AddressSelectionSuccess />} />
        </Route>
        <Route path="customer" element={<CustomerLayout logotype='light' />}>
            <Route path="track/:id" element={<CustomerTrack />} />
            <Route path="reschedule/:orderId" element={<RescheduleOrder />} />
            <Route path="review/:orderId" element={<ReviewDriver />} />
            <Route path="complaint/:orderId" element={<ComplaintDriver />} />
            <Route path="location/:id" element={<CustomerLocationForm />} />
            <Route path="location/task/:id" element={<UpdateTaskAddress />} />
            <Route path="track/task/order" element={<FreelanceCustomerOrderTrack />} />
            <Route path="track/task/:taskId" element={<FreelanceCustomerOrderTrack />} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
    </>
)

export default customerRoutes;
